import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./TTTLoginForm.css";
import { FaUser, FaEnvelope, FaLock, FaFacebookF, FaTwitter, FaLinkedinIn } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";

const TTTLoginForm = () => {

  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
const handleLogin = async (e) => {
  e.preventDefault();

  try {
    const res = await fetch("https://www.talenttrektechnologies.com/certificate-backend/api/login.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ email, password })
    });

    const data = await res.json();

    if (data.success) {

  if (data.role === "admin") {

    // ✅ store admin login
    localStorage.setItem("isAdmin", "true");

    alert("Admin Login Successful ✅");

    // ✅ dashboard ki pampu
    navigate("/admin-1");

  } else {

    localStorage.setItem("isAdmin", "false");

    alert("User Login Successful");

    navigate("/");
  }

} else {
  alert("Invalid Email or Password ❌");
}
  } catch (err) {
    console.log(err);
    alert("Server error");
  }
};

  return (
    <div className="signup-page">
      <div className="overlay">
        <div className="signup-content">

          <div className="left-section">
            <h1>Welcome to Talent Trek Technologies</h1>
            <p>
              Login to explore personalized training, career opportunities, and industry-relevant skills.
              Empower your future with Talent Trek.
            </p>
          </div>

          <div className="right-section">
            <h2><FaUser className="form-title-icon" />Admin Login:</h2>

            <form className="signup-form" onSubmit={handleLogin}>

              <div className="input-box">
                <FaEnvelope className="icon" />
                <input
                  type="email"
                  placeholder="Your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="input-box">
                <FaLock className="icon" />
                <input
                  type="password"
                  placeholder="Your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <button type="submit" className="signup-btn">
                LOGIN
              </button>

              {/* <div className="social-icons">
                <FaFacebookF className="icon fb" />
                <FcGoogle className="icon" />
                <FaTwitter className="icon twitter" />
                <FaLinkedinIn className="icon linkedin" />
              </div> */}
{/* 
              <div className="login-text">
                Don’t have an account? <a href="#">Sign up</a>
              </div> */}

            </form>
          </div>

        </div>
      </div>
    </div>
  );
};

export default TTTLoginForm;